import {
  DownOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Button, Card, Input, Select, Switch } from "antd";
import { memo, useEffect, useState } from "react";
import Question from "../Question/Question";
import reorder from "../../../Util/reorder";

const MultiOption = ({
  index,
  duplicateQuestion,
  duplicateSubQuestion,
  selectLimit,
  noNumber,
  id,
  disabled,
  field_type,
  label,
  options,
  required,
  description,
  onChange,
  noDetail,
  reOrder,
  onRemove,
  newOptionId,
  setNewOptionId,
  formContainer,
  question_number,
}) => {
  const [arrayOptions, setArrayOfOptions] = useState([]);
  const [questionType, setQuestionType] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  useEffect(() => {
    if (field_type && !questionType) {
      setQuestionType(field_type);
    }
  }, [field_type]);
  useEffect(() => {
    if (options && arrayOptions.length === 0) {
      setArrayOfOptions(options);
    }
  }, [options]);

  const addOption = () => {
    const oldOptions = arrayOptions;
    const newOptions = [...oldOptions, { id: newOptionId }];
    setNewOptionId(newOptionId + 1);
    setArrayOfOptions(newOptions);
    onChange("options", newOptions);
  };
  const reomveOption = (id) => {
    const newOptions = [];
    const oldOptions = arrayOptions;
    oldOptions.forEach((opt) => {
      if (opt.id !== id) {
        newOptions.push(opt);
      }
    });
    setArrayOfOptions(newOptions);
    onChange("options", newOptions);
  };
  const editOption = (id, field, value) => {
    const oldOptions = arrayOptions;
    const newOptions = oldOptions.map((opt) => {
      if (opt.id === id) {
        const newOpt = opt;
        newOpt[field] = value;
        return newOpt;
      }
      return opt;
    });
    setArrayOfOptions(newOptions);
    onChange("options", newOptions);
  };
  return (
    <Question
      selectLimit={selectLimit}
      field_type={field_type}
      duplicateQuestion={duplicateQuestion}
      duplicateSubQuestion={duplicateSubQuestion}
      onChange={onChange}
      description={description}
      required={required}
      label={label}
      index={index}
      id={id}
      // type={noNumber ? `${noNumber} - چند گزینه‌ای` : "چند گزینه‌ای"}
      type={"چند گزینه‌ای"}
      disabled={disabled}
      noDetail={noDetail}
      reOrder={reOrder}
      onRemove={onRemove}
      formContainer={formContainer}
      question_number={question_number}
    >
      {!noDetail && (
        <Select
          style={{ width: "100%", marginBottom: "0.5rem" }}
          placeholder="نوع سوال"
          onChange={(e) => {
            setQuestionType(e);
            onChange("field_type", e);
          }}
          value={questionType}
        >
          <Select.Option value="radio">تک انتخابی تستی</Select.Option>
          <Select.Option value="checkboxes">چند انتخابی</Select.Option>
          <Select.Option value="dropdown">لیست کشویی</Select.Option>
          <Select.Option value="nps">مقیاس عددی</Select.Option>
        </Select>
      )}
      <Button
        style={{ width: "100%", marginBottom: "0.5rem" }}
        onClick={() => {
          setShowOptions(!showOptions);
        }}
        type="ghost"
        icon={showOptions ? <UpOutlined /> : <DownOutlined />}
      >
        گزینه‌ها
      </Button>
      {showOptions &&
        arrayOptions.map((opt, index) => {
          return (
            <QuestionOption
              key={opt.id}
              reomveOption={reomveOption}
              editOption={editOption}
              id={opt.id}
              index={index}
              questionType={questionType}
              reOrder={reorder(
                arrayOptions,
                setArrayOfOptions,
                onChange,
                "options",
                index
              )}
              {...opt}
            />
          );
        })}
      {showOptions && (
        <Button
          disabled={disabled}
          type="dashed"
          onClick={() => addOption()}
          style={{
            width: "100%",
          }}
          icon={<PlusOutlined />}
        >
          اضافه کردن گزینه
        </Button>
      )}
    </Question>
  );
};
const QuestionOption = ({
  reomveOption,
  id,
  index,
  questionType,
  label,
  editable,
  clearotheroptions,
  editOption,
  reOrder,
}) => {
  return (
    <Card
      style={{ marginBottom: "0.5rem", border: "2px solid rgba(0,0,0,0.5)" }}
      actions={[
        questionType === "checkboxes" && (
          <div>
            <Switch
              onChange={(checked) => {
                editOption(id, "clearotheroptions", checked);
              }}
              defaultChecked={clearotheroptions}
            />
            <span> متناقض سایر گزینه‌ها </span>
          </div>
        ),
        <div>
          {reOrder.up && (
            <Button
              icon={<UpOutlined />}
              onClick={() => {
                reOrder.up();
              }}
            />
          )}
          {reOrder.down && (
            <Button icon={<DownOutlined />} onClick={() => reOrder.down()} />
          )}
        </div>,
        <div>
          <Switch
            onChange={(checked) => editOption(id, "editable", checked)}
            defaultChecked={editable}
          />
          <span> گزینه متنی </span>
        </div>,
      ]}
    >
      <div style={{ display: "flex" }}>
        <Button
          icon={<MinusCircleOutlined />}
          danger
          type="link"
          onClick={() => reomveOption(id)}
        />
        <Input
          defaultValue={label}
          placeholder={`گزینه ${index + 1}`}
          style={{
            width: "calc(100% - 2rem)",
            border: "1.5px solid rgba(0,0,0,0.35)",
          }}
          // onBlur={(e) => {
          //   editOption(id, "label", e.target.value);
          // }}
          onChange={(e) => {
            editOption(id, "label", e.target.value);
            // if (!e.target.value) {
            //   editOption(id, "optionNumber", e.target.value);
            // }
            // if (/^[0-9.]+$/.test(e.target.value)) {
            //   editOption(id, "optionNumber", e.target.value);
            // }
          }}
        />
      </div>
    </Card>
  );
};
export default memo(MultiOption);
